module.exports = __webpack_public_path__ + "img/0.c482e26e.png";